function startDeliveryTimer() {
  const deliverySpan = document.getElementById("delivery-date");
  const countdownSpan = document.getElementById("countdown");

  if (!deliverySpan || !countdownSpan) return;

  const cutoffHour = 23; // NEW: 11 PM cutoff
  const now = new Date();
  const cutoffTime = new Date();
  cutoffTime.setHours(cutoffHour, 0, 0, 0);

  let deliveryDate = new Date();
  if (now.getHours() < cutoffHour) {
    deliveryDate.setDate(deliveryDate.getDate() + 4);
  } else {
    deliveryDate.setDate(deliveryDate.getDate() + 5);
  }

  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const formattedDate = `${deliveryDate.getDate()} ${months[deliveryDate.getMonth()]}, ${days[deliveryDate.getDay()]}`;
  deliverySpan.textContent = formattedDate;

  function updateCountdown() {
    const now = new Date();
    let timeLeft = cutoffTime - now;

    // If it's past 11PM, set countdown for next day 11PM
    if (timeLeft <= 0) {
      cutoffTime.setDate(cutoffTime.getDate() + 1);
      timeLeft = cutoffTime - now;
    }

    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    countdownSpan.textContent = `${hours}h ${minutes}m ${seconds}s`;
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
}

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const el = document.getElementById("delivery-date");
    const el2 = document.getElementById("countdown");
    if (el && el2) {
      startDeliveryTimer();
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
